import { Injectable } from '@angular/core';
import { createSelector, select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { PermissionList } from '../../core/domain/permission-list.entity';
import { featureSelector, ProjectRootState } from './feature.store';
import { PermissionSliceKey, PermissionSliceState } from './permission.state';

const baseSelector = createSelector(
	featureSelector,
	(state) => state[PermissionSliceKey]
);

const PermissionsSelector = createSelector(baseSelector, (state) => state.all);

@Injectable()
export class PermissionSelector {
	public constructor(private readonly store: Store<ProjectRootState>) {}

	private get state(): Observable<PermissionSliceState> {
		return this.store.pipe(select(baseSelector));
	}

	public getPermissions$(): Observable<PermissionList> {
		return this.store.pipe(select(PermissionsSelector));
	}
}
